export const notificationTargetType = [
  { id: "school", name: "School", color: "#40c4ff" },
  { id: "bus_schedule", name: "Wave", color: "#795548" },
  { id: "route", name: "Route", color: "#7c4dff" },
];
